import { useFacilityStore } from '@/features/_stores'
import type {
  TConfirmAttachmentUploadResponseBodyDTO,
  TCreateAttachmentInputDTO,
  TCreateAttachmentResponseBodyDTO,
  TExposedAttachmentDTO,
  TFindAttachmentByIdResponseBodyDTO,
} from '@doutorsim/shared/exposed/application-attachments'
import { apiClient } from '../api'

class AttachmentsApi {
  private getBaseUrl(applicationId: string) {
    const facility = useFacilityStore.getState().currentFacility

    if (!facility?.id) throw new Error('Company or facility not selected')

    return `/api/v1/companies/${facility.companyId}/facilities/${facility.id}/applications/${applicationId}/attachments`
  }

  async create(applicationId: string, data: TCreateAttachmentInputDTO) {
    const baseUrl = this.getBaseUrl(applicationId)
    return apiClient.post<TCreateAttachmentResponseBodyDTO>(baseUrl, data)
  }

  async confirmUpload(applicationId: string, attachmentId: string) {
    const baseUrl = this.getBaseUrl(applicationId)
    return apiClient.patch<TConfirmAttachmentUploadResponseBodyDTO>(`${baseUrl}/${attachmentId}`)
  }

  async list(applicationId: string) {
    const baseUrl = this.getBaseUrl(applicationId)
    return apiClient.get<TExposedAttachmentDTO[]>(baseUrl)
  }

  async findById(applicationId: string, attachmentId: string) {
    const baseUrl = this.getBaseUrl(applicationId)
    return apiClient.get<TFindAttachmentByIdResponseBodyDTO>(`${baseUrl}/${attachmentId}`)
  }

  async delete(applicationId: string, attachmentId: string) {
    const baseUrl = this.getBaseUrl(applicationId)
    return apiClient.delete(`${baseUrl}/${attachmentId}`)
  }
}

export const attachmentsApi = new AttachmentsApi()
